<template>
  <li
    class="paid-service-row paid-service-row--package"
    :id="rowId"
    :class="{ 'paid-service-row--highlight': highlighted, 'is-open': open }"
  >
    <button
      type="button"
      class="paid-service-row__toggle"
      :aria-expanded="open ? 'true' : 'false'"
      @click="$emit('toggle')"
    >
      <span class="paid-service-row__name">{{ service.name }}</span>
      <span class="paid-service-row__meta">
        <span class="paid-service-row__price">{{ formatPrice(service.price) }}</span>
        <span class="paid-service-row__chevron" :class="{ 'is-open': open }" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
            <path fill="currentColor" d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"/>
          </svg>
        </span>
      </span>
    </button>

    <ul v-if="open" class="paid-package-list">
      <li
        v-for="item in items"
        :key="item.key"
        class="paid-package-row"
      >
        <span class="paid-package-row__name">
          {{ item.name }}
          <span v-if="item.quantity > 1" class="paid-package-row__qty">×&nbsp;{{ item.quantity }}</span>
        </span>
        <span class="paid-package-row__price">{{ formatPrice(item.price) }}</span>
      </li>
    </ul>
  </li>
</template>

<script>
import { resolvePaidPackageItems } from '@/utils/paidPackages';

export default {
  name: 'AppPaidServicePackageRow',
  props: {
    service: { type: Object, required: true },
    paidGroups: { type: Array, default: () => [] },
    open: { type: Boolean, default: false },
    highlighted: { type: Boolean, default: false },
    rowId: { type: String, default: undefined },
    formatPrice: { type: Function, required: true },
  },
  computed: {
    items() {
      return resolvePaidPackageItems(this.service, this.paidGroups);
    },
  },
};
</script>
